import axios from "axios"


class ProductService {
    _url = "http://localhost:"

    getProducts(params) {
        return axios.get("/api/product", {
            params: params
        })
    }

    getProductCount(params) {
        return axios.get("/api/product/count", {
            params: params
        })
    }

    // radom product start

    getRandomProducts(params) {
        return axios.get("/api/random/product", {
            params: params
        })
    }

    getRandomProductCount(params) {
        return axios.get("/api/random/product/count", {
            params: params
        })
    }

    getRandomProduct({id}) {
        return axios.get(`/api/random/product/${id}`)
    }

    // random product end

    getProduct({id}) {
        return axios.get(`/api/product/${id}`)
    }

    productRegister({product}) {
        return axios.post("/api/product/register", product)
    }

    // productChangeStatus({}) {
    //     return axios.post("/api/product/change-status")
    // }

    productDelete({id}) {
        return axios.post(`/api/product/delete/${id}`)
    }

    productUpdate({id, product}) {
        return axios.post(`/api/product/update/${id}`, product)
    }
}

const productService = new ProductService()

export default productService;